module.exports = "https://static.energy5.com/_next/static/images/firstStepHIWImage-d56866cf942bca23cf2dd28ba5d1938e.jpg";